import React from 'react';

import { NavLink } from 'react-router-dom';

import IcSetaEsquerda from '../../components/Svg/IcSetaEsquerda';

import styles from './style.module.css'
import styleButton from '../../components/Button/Button.module.css'

export default function Menu() {
  return (
    <div className={styles.container}>
        <nav>
          <div className={styles.MenuContainer}>
            <div className={styles.MenuItem}>
              <NavLink to="/profile">
                <p>Dados de Cadastro</p>
                <span>Dados da empresa e contrato</span>
              </NavLink>
            </div>
            <div className={styles.MenuItem}>
              <NavLink to="/users">
                <p>Usuários</p>
                <span>Gestão de contas e permissões</span>
              </NavLink>
            </div>
            {/* <div className={styles.MenuItem}>
              <NavLink to="/personalization">
                <p>Personalização</p>
                <span>Atendimentos e recursos</span>
              </NavLink>
            </div> */}
          </div>
        </nav>
        <div>
          <NavLink to="/dashboard" className={styleButton.button_primary_soft} style={{float: "right", marginRight: "2rem"}}>
            <IcSetaEsquerda/>
            <span>Voltar ao menu principal</span>
          </NavLink>
        </div>
      </div>
  );
}
